import _ from 'lodash';
function isDomNode(node) {
    return (typeof _.get(node, 'nodeType') === 'number' &&
        typeof _.get(node, 'nodeName') === 'string');
}
function getDomelement(elem) {
    const domNodeFromZeptoElem = _.get(elem, 0);
    if (isDomNode(domNodeFromZeptoElem)) {
        return domNodeFromZeptoElem;
    }
    if (isDomNode(elem)) {
        return elem;
    }
    return isDomNode(_.get(elem, '0')) && elem;
}
function getDomElementProperty(elem, property) {
    const domElement = getDomelement(elem);
    if (!domElement) {
        return 0;
    }
    return domElement[property];
}
function getOuterWidth(elem) {
    return getDomElementProperty(elem, 'offsetWidth') || 0;
}
function getOuterHeight(elem) {
    return getDomElementProperty(elem, 'offsetHeight') || 0;
}
function setOffset($element, top, left) {
    const curOffset = $element.offset();
    const curTop = parseFloat($element.css('top')) || 0;
    const curLeft = parseFloat($element.css('left')) || 0;
    top = top - curOffset.top + curTop;
    left = left - curOffset.left + curLeft;
    $element.css({ top, left });
}
export { getOuterWidth, getOuterHeight, setOffset };
